'use client'

import { motion } from 'framer-motion'
import Link from 'next/link'
import { trackCTAClick, trackConversion } from '../../../lib/tracking'

export function FunnelHero() {
  return (
    <section className="relative h-[700px] md:h-[800px] lg:h-[947px] overflow-hidden">
      <div className="absolute inset-0 bg-black">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster="/gradient-bg.png"
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="/HumanGlue.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/40" />
      </div>

      <div className="relative z-10 container max-w-7xl mx-auto px-6 flex flex-col justify-center h-full pt-20">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-[#61d8fe] text-lg font-anuphan mb-4"
        >
          For industry leaders, executives, and founders
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-6xl lg:text-[100px] font-normal text-white leading-[1] max-w-[1200px] font-gendy"
        >
          The question isn&apos;t if AI will disrupt your industry. It&apos;s who harnesses it first.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-xl md:text-2xl lg:text-[32px] font-normal text-white/80 leading-[1.3] max-w-[900px] font-anuphan mt-6"
        >
          We architect, build, and scale AI systems that give you your time back and multiply your operational capacity. Choose your point of entry.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <button
            onClick={() => {
              trackConversion('lead', 999)
              document.getElementById('blueprint')?.scrollIntoView({ behavior: 'smooth' })
            }}
            className="bg-[#544ae8] border border-[#475065] rounded-[100px] px-10 py-4 text-white text-lg font-anuphan hover:scale-[1.02] active:scale-[0.98] transition-transform"
          >
            Start with The Blueprint — $999
          </button>
          <button
            onClick={() => {
              trackCTAClick('see_full_journey', '#blueprint')
              document.getElementById('blueprint')?.scrollIntoView({ behavior: 'smooth' })
            }}
            className="border border-white/30 rounded-[100px] px-10 py-4 text-white text-lg font-anuphan hover:bg-white/10 transition-colors"
          >
            See the Full Journey
          </button>
        </motion.div>
      </div>
    </section>
  )
}
